import axios from "axios";
import { waitForReferralCapture } from "../referralCapture";

export const startCheckout = async (products: any, email: string, cancelURL: string, promocode: string) => {
    const data = {
        products: products,
        error_url: cancelURL,
        customer_email: email,
        promocode: promocode
    }

    await waitForReferralCapture();
    return await axios.post(`/api/payment/start`, data, { withCredentials: true })
}

export const getPricing = async (checkoutID: any) => {
    return axios.get(`/api/payment/pricing/${checkoutID}`)
}

export interface PurchaseTracking {
    value: number;
    currency: string;
    event_id: string;
}

export const getPurchaseTracking = (checkoutID: string) =>
    axios.get<PurchaseTracking | null>(`/api/payment/pricing/${checkoutID}`, {
        params: { tracking: true },
    });

export interface PurchaseDownload {
    product_id: string;
    product_name: string;
    windows_download_url: string;
    mac_download_url: string;
}

export interface PurchasedLicense {
    license_key: string;
    product_id: string;
    product_name: string;
    downloads: PurchaseDownload[];
}

export interface PurchaseReceipt {
    status: "pending" | "ready";
    account_linked: boolean;
    licenses: PurchasedLicense[];
}

export const getPurchaseReceipt = (checkoutID: string, checkoutSessionID: string) =>
    axios.post<PurchaseReceipt>(`/api/payment/receipt/${encodeURIComponent(checkoutID)}`, {
        checkout_session_id: checkoutSessionID,
    });
